module.exports = __webpack_public_path__ + "img/access1.1e4c143e.png";